import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { LogoIconLightArt } from '@/shared/assets/icons/logo/logo-icon-light-art';
import { LOGO_ICON_LIGHT_SVG } from '@/shared/assets/icons/logo/logo-icon-light.const';

export const LogoIconLight: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      {...LOGO_ICON_LIGHT_SVG}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <LogoIconLightArt />
    </BaseIcon>
  );
};

LogoIconLight.displayName = 'LogoIconLight';
